import BtnSimple from "@/src-refactor/modules/shared/components/buttons/BtbSimple";
import CheckField from "@/src-refactor/modules/shared/components/fields/check-field/CheckField";
import TextAreaField from "@/src-refactor/modules/shared/components/fields/text-area-field/TextAreaField";
import FormModal from "@/src-refactor/modules/shared/components/modals/form-modal/FormModal";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import { useReportRealEstateMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import { B_ReportParams } from "@/src-refactor/modules/store/qrtk/services/realestate/values/report-realestate.value";
import styled from "@emotion/styled";
import { Form, Formik, FormikConfig, FormikHelpers } from "formik";
import { FC } from "react";
import { useRealEstateDetailContext } from "../../../context/realestate-details.context";
import toast from "react-hot-toast";
import removeEmpty from "@/src-refactor/modules/shared/helpers/remove-empty.helpers";
import MxFormL3TextAreaField from "@rf-l3/form/MxFormL3TextAreaField";

interface IReportProperty {
  custom_id: string;
}

const ReportProperty: FC<IReportProperty> = props => {
  return (
    <FormModal
      title="Reportar propiedad"
      FormComponent={<ReportPropertyForm />}
      btnToggle={<BtnSimple id={props.custom_id} variant-custom="mute" />}
    />
  );
};

export default ReportProperty;

interface IReportPropertyFormProps {
  modalToggle?: () => void;
}

const ReportPropertyForm: FC<IReportPropertyFormProps> = props => {
  const { PROPERTY_DETAIL } = useRealEstateDetailContext();
  const [Report_M, Report_data] = useReportRealEstateMutation();

  const handleClose = () => {
    if (props.modalToggle) {
      props.modalToggle();
    }
  };

  const setup: FormikConfig<B_ReportParams> = {
    initialValues: {
      id: PROPERTY_DETAIL.principalData.id,
      reportImage: false,
      reportDescription: false,
      reportDocuments: false,
      propertyNotAvailable: false,
      comment: "",
      reportLocation: false
    },
    enableReinitialize: true,
    onReset: (v, h: FormikHelpers<any>) => {
      h.resetForm();
      handleClose();
    },
    onSubmit: v => {
      const body = Object.assign(
        v,
        removeEmpty(v as any, {
          trueIsOne: true,
          falseIsCero: true
        })
      );
      Report_M({
        body
      })
        .unwrap()
        .then(res => {
          toast.success("Reporte enviado");
          handleClose();
        })
        .catch(err => {
          toast.error("Reporte no enviado");
        });
    }
  };

  return (
    <Formik {...setup}>
      {formikProps => (
        <ContainerFields>
          <TextSimple color="blue" size="title" font="gotham">
            Seleccione los motivos por la cual se reportara la propiedad
          </TextSimple>

          <CheckField
            useFormik={true}
            name="reportImage"
            label="Reportar imágenes"
          />

          <CheckField
            useFormik={true}
            name="reportDescription"
            label="Reportar descripción"
          />

          <CheckField
            useFormik={true}
            name="reportDocuments"
            label="Reportar documentos"
          />

          <CheckField
            useFormik={true}
            name="reportLocation"
            label="Reportar ubicación"
          />

          <CheckField
            useFormik={true}
            name="propertyNotAvailable"
            label="Propiedad no disponible"
          />

          <MxFormL3TextAreaField
            name="comment"
            label="Comentario"
            placeholder="Agregue un comentario"
          />

          <ContainerButtons>
            <BtnSimple
              variant-custom="red"
              onClick={() => {
                if (props.modalToggle) {
                  props?.modalToggle();
                }
                formikProps.handleReset();
              }}
            >
              Cancelar
            </BtnSimple>
            <BtnSimple variant-custom="blue-main" type="submit">
              Enviar
            </BtnSimple>
          </ContainerButtons>
        </ContainerFields>
      )}
    </Formik>
  );
};

const ContainerFields = styled(Form)`
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 50px;
`;

const ContainerButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  position: absolute;
  z-index: 2000;
  bottom: 0;
  left: 0;
  background-color: white;
  padding: 20px;
`;
